import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "TrainingSubType/";

const getTrainingSubTypeById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetTrainingSubTypeById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getTrainingSubTypes = async (trainingTypeId, showArchived) => await axiosInstance.get(ENDPOINTORIGIN + 'GetTrainingSubTypes?trainingTypeId=' + trainingTypeId + '&showArchived=' + showArchived, constants.REQUIRE_INTERCEPTORS);

const saveTrainingSubType = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveTrainingSubType', model, constants.REQUIRE_INTERCEPTORS);

const archiveTrainingSubType = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'ArchiveTrainingSubType?id=' + id, constants.REQUIRE_INTERCEPTORS);

const unarchiveTrainingSubType = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'UnarchiveTrainingSubType?id=' + id, constants.REQUIRE_INTERCEPTORS);
export {
    getTrainingSubTypeById,
    getTrainingSubTypes,
    saveTrainingSubType,
    archiveTrainingSubType,
    unarchiveTrainingSubType
}